import React, { useEffect, useRef } from 'react';
import ApiURLs from 'services/BackendApi/BackendApiURLs';
import { Wrapper } from "@googlemaps/react-wrapper";
import MapItext from './MapItext_bk';

function MyMapComponent({
    center,
    zoom,
}) {
    const ref = useRef();

    useEffect(() => {
        new window.google.maps.Map(ref.current, {
            center,
            zoom,
        });
    });

    return <div ref={ref} id="map" />;
}

export default function MapItext_copy(props) {
    const { item } = props;
    const mapContainerRef = useRef(null);
    //console.log("ENTRAAAAAA")
    const MyApp = () => (
        <Wrapper apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
            <MyMapComponent center={{lat:31.703765,lng:-98.123923}} zoom={5}/>
        </Wrapper>
    );

    return (
        <div className="App" style={{ width: "100%", height: "100%" }}>
        <Wrapper apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
            {/* <MyMapComponent center={{lat:31.703765,lng:-98.123923}} zoom={5}/> */}
            <MapItext item={item}/>
        </Wrapper>
        </div>
    )
}
